// extracted by mini-css-extract-plugin
module.exports = {"heading":"heading_heading__3GLkg","h1":"heading_h1__2Oc_o","h2":"heading_h2__17cgf","h3":"heading_h3__onCpE","h4":"heading_h4__319Nb","h5":"heading_h5__1rBTr"};